import { useCallback, useEffect, useState } from "react";

import { useStorage } from "./useStorage";

interface AgGridColumnState {
  columnState?: { hide?: boolean }[];
}

export function useAgGridHiddenColumns(): {
  hiddenColumnsCount: (gridId: string) => number;
} {
  const { getStorageItem } = useStorage("session");
  // Re-renders consumers whenever the grid saves state to session storage.
  const [, setVersion] = useState(0);

  useEffect(() => {
    const bump = (): void => setVersion((n) => n + 1);
    window.addEventListener("agGridStateSaved", bump);
    return () => window.removeEventListener("agGridStateSaved", bump);
  }, []);

  const hiddenColumnsCount = useCallback(
    (gridId: string): number => {
      const state = getStorageItem<AgGridColumnState>(`aggrid_${gridId}_state`);
      return state?.columnState?.filter((col) => col.hide === true).length ?? 0;
    },
    [getStorageItem],
  );

  return { hiddenColumnsCount };
}
